import React from "react";
import Typography from "@mui/material/Typography";

type ExternalLinkProps = {
  link: string;
  text?: string;
  children?: React.ReactElement;
  style?: Object;
};

export default function ExternalLink(props: ExternalLinkProps) {
  const { link, text, children, style } = props;
  return (
    <a target="_blank" href={link} rel="noopener noreferrer" style={style}>
      {children ? children : <Typography component="span">{text}</Typography>}
    </a>
  );
}
